"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { submitting: false };
        this.fhandler = new FormHandler({
            key: 'add-user',
            autosave: true
        });
        this.fhandler.bind(this);
    },
    onMount: function () {
        const title = 'Adding User';
        this.fhandler.on('autosave', () => GState.activity.add({
            title,
            path: '/add-user'
        })).on('reset', () => GState.activity.remove(title));
    },
    onSelectAccountType: function (value) {
        if (value !== 'admin')
            delete this.state.form.userRole;
        this.fhandler.set('accountType', value);
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.fullname)
            return this.state.formError.fullname = true;
        if (!Form.email)
            return this.state.formError.email = true;
        if (!Form.accountType)
            return this.state.formError.accountType = true;
        this.state.submitting = true;
        try {
            const {error, message} = await Request('/invitation/send', 'POST', Form);
            this.state.submitting = false;
            this.fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            this.fhandler.reset();
        } catch (error) {
            this.state.submitting = false;
            this.fhandler.alert(error);
        }
    },
    onReset: function () {
        this.fhandler.reset();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Users/Instructor/Instructors/View/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    WSAdapt_template = require("../../../../../../components/WSAdapt/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_Admin_template = require("../../../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template);

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "d-flex justify-content-center",
      renderBody: function(out, { page, themeMode }) {
        WSAdapt_tag({
            qs: "col-xl-6",
            hs: "col-xl-9",
            class: "col-xl-5 col-lg-7 col-md-10",
            renderBody: function(out) {
              out.t("View user");
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
